import React from 'react';
import { Target, Eye } from 'lucide-react';
import { companyInfo, about, images } from '../mock';

const About = () => {
  return (
    <div className="min-h-screen">
      {/* Page Header */}
      <section
        className="relative h-[300px] bg-cover bg-center flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${images.corporate})`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 className="text-5xl font-bold mb-4">About Us</h1>
          <p className="text-xl">Get to know Jupiter Group</p>
        </div>
      </section>

      {/* Company Description */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Who We Are</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                {about.description}
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                As a newly established business this year, we are committed to building strong relationships with our
                clients through transparency, reliability, and professional excellence.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src={images.about}
                alt="Jupiter Group Team"
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Vision and Mission */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Vision */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-center mb-6">
                <div className="bg-blue-100 p-3 rounded-full">
                  <Eye className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 ml-4">Our Vision</h3>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                {about.vision}
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-center mb-6">
                <div className="bg-blue-100 p-3 rounded-full">
                  <Target className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 ml-4">Our Mission</h3>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                To provide exceptional manpower solutions that meet the evolving needs of businesses while maintaining
                the highest standards of compliance, transparency, and professionalism in all our operations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Management */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Leadership</h2>
            <p className="text-xl text-gray-600">Professional management driving excellence</p>
          </div>
          <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-200">
            <div className="text-center">
              <div className="mb-4">
                <div className="w-24 h-24 bg-blue-100 rounded-full mx-auto flex items-center justify-center">
                  <span className="text-3xl font-bold text-blue-600">
                    {companyInfo.managingDirector.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{companyInfo.managingDirector}</h3>
              <p className="text-lg text-gray-600 mb-4">Managing Director</p>
              <p className="text-gray-700">
                Leading Jupiter Group with a commitment to excellence, integrity, and client satisfaction.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
